import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconColumnWideHalf: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconColumnWideHalf"><Path d="M2 11V4H22V11H2Z" fill="currentColor"/><Path d="M2 13V20H22V13H2Z" fill="currentColor"/></CentralIconBase>;
});

export default IconColumnWideHalf;
